var _path;
import * as React from "react";
function SvgCheckmarkFill(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 20c0 8.837-7.163 16-16 16S4 28.837 4 20 11.163 4 20 4s16 7.163 16 16zm-17.85 8.472L30.02 16.6a1.032 1.032 0 000-1.46l-1.46-1.46a1.032 1.032 0 00-1.46 0l-9.68 9.682-4.52-4.52a1.032 1.032 0 00-1.46 0l-1.46 1.46a1.032 1.032 0 000 1.46l6.71 6.709a1.032 1.032 0 001.46 0z"
  })));
}
export default SvgCheckmarkFill;